import { LoadState } from "../../constants/enums";
import { ICompanyOutlet, ICompanyOutletState } from "./companyOutlet.types";

export const initialCompanyOutlet: ICompanyOutlet = {
	company_outlet_uuid: "",
	company_outlet_name: "",
	remark: "",
	status: "ACTIVE",
	create_ts: "",
	insert_ts: "",
	created_by_uuid: "",
	columns: [],
	module_name: "",
	customised_column_uuid: null,
	dynamic_field: [],
};

export const initialCustomisedColumn = {
	customised_column_uuid: "",
	company_outlet_uuid: "",
	module_name: "",
	dynamic_field: [],
	status: "ACTIVE",
	created_by_uuid: "",
	created_by_name: "",
	modified_by_uuid: "",
	modified_by_name: "",
	create_ts: "",
	insert_ts: ""
};


export const initialCompanyOutletState: ICompanyOutletState = {
	list: {
		list: [],
		totalRecords: 0,
		loading: LoadState.NotLoaded,
		error: null,
	},
	companyOutlet: {
		data: initialCompanyOutlet,
		loading: LoadState.NotLoaded,
		error: null,
	},
	customisedColumn: {
		list: [],
		loading: LoadState.NotLoaded,
		error: null,
	},
};
